module.exports = __webpack_public_path__ + "static/img/case15.b3eda17.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/case/case15.jpg
// module id = anuG
// module chunks = 0